export default __webpack_public_path__ + "static/media/work-2left-3.a88bde76.png";